import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'date'})
export class CustomDatePipe implements PipeTransform {
    transform(date: Date | string, format?: string): string {
        if (!date) return ''
        date = date instanceof Date ? date : new Date(date);
        if (format === 'yyyy-MM-dd') return date.toLocaleDateString('en-CA', { timeZone: 'Europe/Paris' })
        else if (format === 'longDate') return date.toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris', day: 'numeric', month: 'long', year: 'numeric' });
        else return date.toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris' });
    };
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/date.pipe.ts